/* eslint-disable no-console */
class Logger {
    debug(...evt) {
        console.debug(...evt);
    }

    warn(...evt) {
        console.warn(...evt);
    }

    error(...evt) {
        console.error(...evt);
    }

    info(...evt) {
        console.log(...evt);
    }
}

export default new Logger();
